import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import OfferPagePromoLandings from './OfferPagePromoLandings';
import { actions } from './OfferPagePromoLandings.actions';
import { withTemplateConfig } from '../../../../context/TemplateConfigContext';
import {
    getHeaderNames,
    getLandings,
    getLandingsGallery,
    getHostingTypes,
    getProportions
} from './OfferPagePromoLandings.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    headerNames: getHeaderNames,
    landings: getLandings,
    landingsGallery: getLandingsGallery,
    hostingTypes: getHostingTypes,
    proportions: getProportions
});

const OfferPagePromoLandingsComponent = connect(
    function mapStateToProps(state, ownProps) {
        return {
            ...mapStateToPropsSelectors(state, ownProps),
            loading: state.landings.loading,
            totalPages: state.landings.total
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getLandings: actions.getLandings,
            saveLanding: actions.saveLanding,
            getOfferLinks: actions.getOfferLinks
        };
    }
)(OfferPagePromoLandings);

export default withTemplateConfig(OfferPagePromoLandingsComponent);
